import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { ITipCalculatorResultSplitCheckContribution } from 'types';
import { centsToDollarsDisplay } from 'utils/currency';

interface ISplitChecksContributingProps {
  className?: string;
  dataCy?: string;
  values: ITipCalculatorResultSplitCheckContribution[];
}

const Col = styled.div`
  @media (max-width: ${theme.breakpoint.small}) {
    &:not(:first-child),
    &:not(:last-child) {
      display: none;
    }
  }

  &:last-child {
    justify-content: end;
  }
`;

const ReceivingBreakdownLayout = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 1fr;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: ${toRem(12)};
  color: ${theme.color.neutral[900]};
  width: 100%;

  &:not(:last-child) {
    margin-bottom: ${toRem(8)};
  }
`;

const HeaderRow = styled(Row)`
  font-size: ${toRem(12)};
  color: ${theme.color.neutral[500]};
  font-weight: ${theme.font.weight.medium};
`;

const TotalRow = styled(Row)`
  font-weight: ${theme.font.weight.bold};
`;

const SplitChecksContributing: React.FC<ISplitChecksContributingProps> = ({ className = '', dataCy = 'split-checks-contributing', values }) => {
  const renderLineItems = () =>
    (values || []).map((value) => {
      const { displayId, totals } = value;

      return (
        <Row key={displayId} data-cy={`${dataCy}-line-item`}>
          <Col>#{displayId}</Col>
          <Col>{centsToDollarsDisplay(totals.gross)}</Col>
          <Col>{centsToDollarsDisplay(totals.tip.creditCardFee + totals.autoGratuity.creditCardFee)}</Col>
          <Col>{centsToDollarsDisplay(totals.net)}</Col>
        </Row>
      );
    });

  return (
    <ReceivingBreakdownLayout className={className} data-cy={dataCy}>
      <HeaderRow data-cy={`${dataCy}-header`}>
        <Col>Check Number</Col>
        <Col>Gross</Col>
        <Col>CC Fee</Col>
        <Col>Amount</Col>
      </HeaderRow>

      {renderLineItems()}

      <TotalRow data-cy={`${dataCy}-total`}>
        <Col>Total</Col>
        <Col />
        <Col />
        <Col>{centsToDollarsDisplay((values || []).reduce((acc, curr) => acc + curr.totals.net, 0))}</Col>
      </TotalRow>
    </ReceivingBreakdownLayout>
  );
};

export default SplitChecksContributing;
